import { useContext } from 'react'

import { Hint } from '@factorialco/deprecated-design-system'
import UpsellKanbanImage from 'assets/images/project_management/modals/upsell_kanban_tasks_modal/kanban_hint_modal.svg'
import UpsellSchedule from 'assets/images/project_management/modals/upsell_schedule_modal/upsell_schedule.png'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'
import { EnvironmentContext } from 'config/environment'
import { compact } from 'lodash'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

export const AnnouncementModal = () => {
  const { hideProjectUpsellClientsModal } = useContext(EnvironmentContext)
  const [announcementScheduleModalIsHidden, setAnnouncementScheduleModalIsHidden] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideProjectsScheduleModal)
  const [announcementKanbanTasksModalIsHidden, setAnnouncementKanbanTasksModalIsHidden] =
    useLocalStorage<boolean>(
      LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideProjectsAnnouncementKanbanTasksModal
    )

  if (hideProjectUpsellClientsModal) return
  if (announcementScheduleModalIsHidden && announcementKanbanTasksModalIsHidden) return null

  const handleModalClose = () => {
    setAnnouncementScheduleModalIsHidden(true)
    setAnnouncementKanbanTasksModalIsHidden(true)
  }

  const steps = compact([
    !announcementScheduleModalIsHidden
      ? {
          src: UpsellSchedule,
          title: i18n.t('project_management.modals.upsell_projects_modal.step_schedule.title'),
          description: i18n.t(
            'project_management.modals.upsell_projects_modal.step_schedule.description'
          ),
        }
      : null,
    !announcementKanbanTasksModalIsHidden
      ? {
          src: UpsellKanbanImage,
          title: i18n.t('project_management.modals.upsell_projects_modal.step_kanban.title'),
          description: i18n.t(
            'project_management.modals.upsell_projects_modal.step_kanban.description'
          ),
        }
      : null,
  ])

  return (
    <Hint.NewModal onClose={handleModalClose} onFinish={handleModalClose}>
      {steps.map((step, index) => (
        <Hint.NewModal.ImageStep
          key={index}
          src={step.src}
          title={step.title}
          description={step.description}
        />
      ))}
    </Hint.NewModal>
  )
}
